import { TeamInfoFooter } from './footer';
import { TeamInfoHeader } from './header';
import { TeamMembersInfo } from './membersInfo';

export const TeamInfo = {
  Header: TeamInfoHeader,
  Members: { Info: TeamMembersInfo, Footer: TeamInfoFooter },
};
